import { useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import UserService from '../../../http/user-service';
import { DbUser } from '../../../types/user';

interface DeleteUserDialogProps {
    user: DbUser;
    open: boolean;
    onClose: () => void;
    onDeleted: () => void;
}

const DeleteUserDialog = ({ user, open, onClose, onDeleted }: DeleteUserDialogProps) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        if (loading) return;
        setError('');
        onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        setError('');
        try {
            await UserService.remove(user.user_id);
            onDeleted();
            onClose();
        } catch {
            setError('Не удалось удалить пользователя');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            onKeyDown={(e) => { if (e.key === 'Enter' && !loading) handleConfirm(); }}
        >
            <DialogTitle>Удалить пользователя</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Вы точно хотите удалить пользователя «{user.login}»?
                </DialogContentText>
                {error && <DialogContentText color="error" sx={{ mt: 1 }}>{error}</DialogContentText>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>Отмена</Button>
                <Button onClick={handleConfirm} color="error" variant="contained" disabled={loading} disableElevation autoFocus>
                    {loading ? <CircularProgress size={18} /> : 'Удалить'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteUserDialog;
